import { render, staticRenderFns } from "./ContestSwornListComponent.vue?vue&type=template&id=28db00f8&scoped=true"
import script from "./ContestSwornListComponent.vue?vue&type=script&lang=js"
export * from "./ContestSwornListComponent.vue?vue&type=script&lang=js"
import style0 from "./ContestSwornListComponent.vue?vue&type=style&index=0&id=28db00f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28db00f8",
  null
  
)

export default component.exports